<script>
import SelectField from '@/components/SelectField/SelectField.vue'
import WithLoader from '@/components/WithLoader'

export default WithLoader(SelectField, {
  events: ['input', 'open', 'close'],
  pendingProp: 'loading',
})
</script>
